import { TYPO } from "styles/Typo";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ActiveRadioIcon, InactiveRadioIcon } from "../util/Icon";
import { SAA_SURVEY_META } from "utils/constant/STATUS";
import { SurveyTitle } from "../util/component";

interface Step4Props {
  selectedOption: string;
  onOptionSelect: (option: string) => void;
  expenseCategory: string;
  question?: string;
  options?: { id: string; label: string }[];
}

export default function Step4({
  selectedOption,
  onOptionSelect,
  expenseCategory,
  question,
  options: externalOptions,
}: Step4Props) {
  const optionRefs = useRef<Array<HTMLDivElement | null>>([]);
  const options = externalOptions || [
    {
      id: "within_3y",
      label: "3년 이내",
    },
    {
      id: "after_5y",
      label: "5년",
    },
    {
      id: "after_7y",
      label: "7년",
    },
    {
      id: "after_10y",
      label: "10년",
    },
    {
      id: "unknown",
      label: "잘 모름",
    },
  ];

  // title : step2(expenseCategory)에 따른 의존
  let title: string =
    SAA_SURVEY_META["expense_category"]?.[expenseCategory]?.label + "에 쓸";

  useEffect(() => {
    const tl = gsap.timeline();
    const elements = optionRefs.current.filter(
      (el): el is HTMLDivElement => !!el
    );

    tl.fromTo(
      elements,
      {
        opacity: 0,
        x: (index: number) => 15 + index * 10,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.8,
        ease: "easeInOut",
        stagger: 0.1,
      },
      "+=0.2"
    );
  }, []);

  return (
    <div className="bg-background relative w-full   ">
      {/* Question Container */}
      <div className="content-stretch flex flex-col items-start justify-start w-full">
        {/* <SurveyTitle text={title} /> */}
        <div className="pt-4 px-6 space-y-1">
          <p className={`${TYPO.TYPO7_MD} text-blue50`}>{title}</p>
          <p
            className={` w-full text-[26px] leading-[140%] font-[600]  text-gray90 whitespace-pre-line`}
          >
            돈은 언제 필요한가요?
          </p>
        </div>

        {/* Options Container */}
        <div className="box-border content-stretch flex flex-col items-start justify-center px-6 py-4 relative shrink-0 w-full overflow-x-hidden">
          {options.map((option, index) => (
            <div
              key={index}
              ref={(el) => {
                optionRefs.current[index] = el;
              }}
              className="box-border content-stretch flex gap-2 items-center justify-start px-1 py-2.5 relative shrink-0 w-full cursor-pointer"
              onClick={() => onOptionSelect(option.id)}
              data-testid={`saa-consume-survey-step4-${option.id}-btn`}
              data-gtm-id={`saa-survey-timing-btn`}
            >
              {/* Radio Button */}
              <div className="relative shrink-0 size-5">
                <div className="absolute inset-[8.333%]">
                  {selectedOption === option.id ? (
                    <ActiveRadioIcon />
                  ) : (
                    <InactiveRadioIcon />
                  )}
                </div>
              </div>

              {/* Option Label */}
              <div
                className={`basis-0 grow min-h-px min-w-px ${
                  selectedOption === option.id ? "text-blue50" : "text-gray80"
                } ${TYPO.TYPO5_1_MD}`}
              >
                {option.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
